// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1L7ZO","sendOtp":"AuthorizeToLogin_sendOtp__nfbEy"};